import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Assistant\",\"arguments\":[{\"subsets\":[\"latin\",\"hebrew\"],\"variable\":\"--font-assistant\",\"display\":\"swap\"}],\"variableName\":\"assistant\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Playfair_Display\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-playfair\",\"display\":\"swap\"}],\"variableName\":\"playfair\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorTracker"] */ "/app/src/components/ErrorTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SessionReplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetBoundary"] */ "/app/src/components/WidgetBoundary.tsx");
